import { DeductibleExpense, LocalTaxMode, TaxesDTO, TaxEstimationMode } from './api/useTaxesQuery';
import { SaveTaxesBody } from './api/useSaveTaxesMutation';

export const FORM_ID = 'form--profile-taxes';

export const NEW_YORK_STATE = 31;

export type TaxesFormVariant = 'base' | 'preRetirementOverride' | 'postRetirement';

export interface FormValues {
  preRetirementTaxEstimationMode: TaxEstimationMode;
  postRetirementTaxEstimationMode: TaxEstimationMode;
  preRetirementLocalTaxMode: LocalTaxMode;
  postRetirementLocalTaxMode: LocalTaxMode;
  postRetirementSelectedFilingState: number;
  preRetirementPercentageLocalTax: number;
  postRetirementPercentageLocalTax: number;
  preRetirementFlatLocalTax: number;
  postRetirementFlatLocalTax: number;
  preRetirementEffectiveTaxRate: number;
  postRetirementEffectiveTaxRate: number;
  useDifferentPostRetirementTaxes: boolean;
  useDifferentPreRetirementTaxes: boolean;
  preRetirementTaxEffectiveYear: number | null;
  preRetirementOverrideTaxEstimationMode: TaxEstimationMode;
  preRetirementSelectedFilingState: number | null;
  preRetirementOverrideLocalTaxMode: LocalTaxMode;
  preRetirementOverridePercentageLocalTax: number;
  preRetirementOverrideFlatLocalTax: number;
  preRetirementOverrideEffectiveTaxRate: number;
  useStandardDeductions: boolean;
  itemizedDeductibleExpenses: DeductibleExpense[];
}

export const dataToForm = (data: TaxesDTO): FormValues => {
  return {
    preRetirementTaxEstimationMode: data.taxEstimationMode,
    postRetirementTaxEstimationMode: data.postRetirementtaxEstimationMode,
    preRetirementLocalTaxMode: data.localTaxMode,
    postRetirementLocalTaxMode: data.postRetirementLocalTaxMode,
    postRetirementSelectedFilingState: data.postRetirementSelectedFilingState,
    preRetirementPercentageLocalTax: data.percentageLocalTax,
    postRetirementPercentageLocalTax: data.postRetirementPercentageLocalTax,
    preRetirementFlatLocalTax: data.flatLocalTax,
    postRetirementFlatLocalTax: data.postRetirementFlatLocalTax,
    preRetirementEffectiveTaxRate: data.effectiveTaxRate,
    postRetirementEffectiveTaxRate: data.postRetirementEffectiveTaxRate,
    useDifferentPostRetirementTaxes: data.useDifferentPostRetirementTaxes,
    useDifferentPreRetirementTaxes: data.useDifferentPreRetirementTaxes,
    preRetirementTaxEffectiveYear: data.preRetirementTaxEffectiveYear,
    preRetirementOverrideTaxEstimationMode: data.preRetirementTaxEstimationMode,
    preRetirementSelectedFilingState: data.preRetirementSelectedFilingState,
    preRetirementOverrideLocalTaxMode: data.preRetirementLocalTaxMode,
    preRetirementOverridePercentageLocalTax: data.preRetirementPercentageLocalTax,
    preRetirementOverrideFlatLocalTax: data.preRetirementFlatLocalTax,
    preRetirementOverrideEffectiveTaxRate: data.preRetirementEffectiveTaxRate,
    useStandardDeductions: data.useStandardDeductions,
    itemizedDeductibleExpenses: data.itemizedDeductibleExpenses.sort((a, b) => {
      if (a.isPrepopulatedField === b.isPrepopulatedField) {
        return 0;
      }
      return a.isPrepopulatedField ? -1 : 1;
    }),
  };
};

export const formToBody = (values: FormValues): SaveTaxesBody => {
  return {
    taxEstimationMode: values.preRetirementTaxEstimationMode,
    postRetirementtaxEstimationMode: values.postRetirementTaxEstimationMode,
    localTaxMode: values.preRetirementLocalTaxMode,
    postRetirementLocalTaxMode: values.postRetirementLocalTaxMode,
    postRetirementSelectedFilingState: values.postRetirementSelectedFilingState,
    percentageLocalTax: values.preRetirementPercentageLocalTax,
    postRetirementPercentageLocalTax: values.postRetirementPercentageLocalTax,
    flatLocalTax: values.preRetirementFlatLocalTax,
    postRetirementFlatLocalTax: values.postRetirementFlatLocalTax,
    effectiveTaxRate: values.preRetirementEffectiveTaxRate,
    postRetirementEffectiveTaxRate: values.postRetirementEffectiveTaxRate,
    useDifferentPostRetirementTaxes: values.useDifferentPostRetirementTaxes,
    useDifferentPreRetirementTaxes: values.useDifferentPreRetirementTaxes,
    preRetirementTaxEffectiveYear: values.preRetirementTaxEffectiveYear,
    preRetirementTaxEstimationMode: values.preRetirementOverrideTaxEstimationMode,
    preRetirementSelectedFilingState: values.preRetirementSelectedFilingState,
    preRetirementEffectiveTaxRate: values.preRetirementOverrideEffectiveTaxRate,
    preRetirementLocalTaxMode: values.preRetirementOverrideLocalTaxMode,
    preRetirementFlatLocalTax: values.preRetirementOverrideFlatLocalTax,
    preRetirementPercentageLocalTax: values.preRetirementOverridePercentageLocalTax,
    useStandardDeductions: values.useStandardDeductions,
    itemizedDeductibleExpenses: values.itemizedDeductibleExpenses,
  };
};
